import { useContext } from 'react'
import { TranslationContext, type TranslationValue } from '../context/translation-context-value'

export function useTranslation(): TranslationValue {
  return useContext(TranslationContext)
}
